module.exports = "/_next/static/images/arrow_left_long-047c5ab823f0d98e71978a001238fca3.svg";